import './Playground.css';

import React from 'react';
import Typing from 'react-typing-animation';

function Playground(props) {
  const [statusVisible, setStatusVisible] = React.useState('hidden');

  React.useEffect(
    () => {
      if (!props.text) { setStatusVisible('hidden'); }
    },
    [props.text],
  )

  return (
    <div className="playground-container">
      <div className="playground">
        <i class="fa fa-paper-plane sent-icon" />
        {!!props.text && <Typing onFinishedTyping={() => { setStatusVisible('visible'); props.increment(); }}>
          <span>
            {props.text}
          </span>
        </Typing>}
      </div>

      <div className="status-container" style={{ visibility: statusVisible }}>
        <div className="dot" style={{ backgroundColor: props.color }} />
        <span className="playground-status" style={{ color: props.color }}>
          {props.status}
        </span>
      </div>
    </div >
  );
}

export default React.memo(Playground);
